/** Stable, machine-readable error codes. Clients switch on these, never on messages. */
export const ERROR_CODES = {
    MAIL_DELIVERY_DISABLED: 'MAIL_DELIVERY_DISABLED',
    MIGRATION_MASTER_REVIEW_REQUIRED: 'MIGRATION_MASTER_REVIEW_REQUIRED',
    INTRODUCTION_BLOCKED: 'INTRODUCTION_BLOCKED',
    INTRODUCTION_STALE: 'INTRODUCTION_STALE',
    VALIDATION_FAILED: 'VALIDATION_FAILED',
    UNAUTHENTICATED: 'UNAUTHENTICATED',
    FORBIDDEN: 'FORBIDDEN',
    NOT_FOUND: 'NOT_FOUND',
    METHOD_NOT_ALLOWED: 'METHOD_NOT_ALLOWED',
    PORTAL_PRICE_CHANGED: 'PORTAL_PRICE_CHANGED',
    PORTAL_CART_CONFLICT: 'PORTAL_CART_CONFLICT',
    CONFLICT_VERSION_MISMATCH: 'CONFLICT_VERSION_MISMATCH',
    BUSINESS_RULE_VIOLATION: 'BUSINESS_RULE_VIOLATION',
    RATE_LIMITED: 'RATE_LIMITED',
    PAYLOAD_TOO_LARGE: 'PAYLOAD_TOO_LARGE',
    TENANT_CONTEXT_MISSING: 'TENANT_CONTEXT_MISSING',
    SERVICE_UNAVAILABLE: 'SERVICE_UNAVAILABLE',
    INTERNAL_ERROR: 'INTERNAL_ERROR',
    FEATURE_DISABLED: 'FEATURE_DISABLED',
    MAINTENANCE_MODE: 'MAINTENANCE_MODE',
    // Vertriebsassistent und Kundenpflege
    SALES_RULE_KEY_EXISTS: 'SALES_RULE_KEY_EXISTS',
    SALES_RECOMMENDATION_RUN_ACTIVE: 'SALES_RECOMMENDATION_RUN_ACTIVE',
    SALES_TASK_ACTIVE_RECOMMENDATION: 'SALES_TASK_ACTIVE_RECOMMENDATION',
    SALES_TASK_CLAIMED: 'SALES_TASK_CLAIMED',
    SALES_TASK_STATE_INVALID: 'SALES_TASK_STATE_INVALID',
    SALES_TASK_ACCESS_DENIED: 'SALES_TASK_ACCESS_DENIED',
    SALES_DELEGATION_OVERLAP: 'SALES_DELEGATION_OVERLAP',
    SALES_CONTACT_OUTCOME_EXISTS: 'SALES_CONTACT_OUTCOME_EXISTS',
    SALES_SAVED_VIEW_NAME_EXISTS: 'SALES_SAVED_VIEW_NAME_EXISTS',
    SALES_COCKPIT_SELECTION_INVALID: 'SALES_COCKPIT_SELECTION_INVALID',
    SALES_RULE_SIMULATION_REQUIRED: 'SALES_RULE_SIMULATION_REQUIRED',
    // Banking / regulierte Kontoinformationen
    BANKING_PROVIDER_NOT_CONFIGURED: 'BANKING_PROVIDER_NOT_CONFIGURED',
    BANKING_PROVIDER_APPROVAL_REQUIRED: 'BANKING_PROVIDER_APPROVAL_REQUIRED',
    BANKING_PROVIDER_AUTHENTICATION_FAILED: 'BANKING_PROVIDER_AUTHENTICATION_FAILED',
    BANKING_PROVIDER_RATE_LIMITED: 'BANKING_PROVIDER_RATE_LIMITED',
    BANKING_PROVIDER_UNAVAILABLE: 'BANKING_PROVIDER_UNAVAILABLE',
    BANKING_INSTITUTION_UNAVAILABLE: 'BANKING_INSTITUTION_UNAVAILABLE',
    BANKING_CALLBACK_INVALID: 'BANKING_CALLBACK_INVALID',
    BANKING_CALLBACK_REPLAYED: 'BANKING_CALLBACK_REPLAYED',
    BANKING_CONSENT_EXPIRED: 'BANKING_CONSENT_EXPIRED',
    BANKING_SCA_REQUIRED: 'BANKING_SCA_REQUIRED',
    BANKING_WEBHOOK_SIGNATURE_INVALID: 'BANKING_WEBHOOK_SIGNATURE_INVALID',
    BANKING_IDEMPOTENCY_CONFLICT: 'BANKING_IDEMPOTENCY_CONFLICT',
    BANKING_SYNC_ALREADY_RUNNING: 'BANKING_SYNC_ALREADY_RUNNING',
    BANKING_SYNC_NOT_READY: 'BANKING_SYNC_NOT_READY',
    BANKING_SYNC_DISABLED: 'BANKING_SYNC_DISABLED',
    BANKING_SYNC_FAILED: 'BANKING_SYNC_FAILED',
    BANKING_MATCH_NOT_ELIGIBLE: 'BANKING_MATCH_NOT_ELIGIBLE',
    BANKING_MATCH_CONFLICT: 'BANKING_MATCH_CONFLICT',
    BANKING_POSTING_NOT_ELIGIBLE: 'BANKING_POSTING_NOT_ELIGIBLE',
    BANKING_POSTING_STALE: 'BANKING_POSTING_STALE',
    BANKING_POSTING_CONFLICT: 'BANKING_POSTING_CONFLICT',
    BANKING_AUTO_POSTING_DISABLED: 'BANKING_AUTO_POSTING_DISABLED',
    BANKING_POSTING_ALREADY_REVERSED: 'BANKING_POSTING_ALREADY_REVERSED',
    // Authentifizierung
    INVALID_CREDENTIALS: 'INVALID_CREDENTIALS',
    TENANT_SELECTION_REQUIRED: 'TENANT_SELECTION_REQUIRED',
    ACCOUNT_LOCKED: 'ACCOUNT_LOCKED',
    ACCOUNT_INACTIVE: 'ACCOUNT_INACTIVE',
    REFRESH_TOKEN_INVALID: 'REFRESH_TOKEN_INVALID',
    TWO_FACTOR_REQUIRED: 'TWO_FACTOR_REQUIRED',
    TWO_FACTOR_INVALID: 'TWO_FACTOR_INVALID',
    TWO_FACTOR_ALREADY_ENABLED: 'TWO_FACTOR_ALREADY_ENABLED',
    TWO_FACTOR_NOT_ENABLED: 'TWO_FACTOR_NOT_ENABLED',
    PASSWORD_POLICY_VIOLATED: 'PASSWORD_POLICY_VIOLATED',
    PASSWORD_REUSED: 'PASSWORD_REUSED',
    PASSWORD_CHANGE_REQUIRED: 'PASSWORD_CHANGE_REQUIRED',
    EMAIL_TAKEN: 'EMAIL_TAKEN',
    ROLE_IN_USE: 'ROLE_IN_USE',
    ROLE_IMMUTABLE: 'ROLE_IMMUTABLE',
    ROLE_NAME_TAKEN: 'ROLE_NAME_TAKEN',
    SELF_MODIFICATION_FORBIDDEN: 'SELF_MODIFICATION_FORBIDDEN',
    PORTAL_INVITATION_INVALID: 'PORTAL_INVITATION_INVALID',
    PORTAL_INVITATION_EXPIRED: 'PORTAL_INVITATION_EXPIRED',
    PORTAL_INVITATION_ALREADY_USED: 'PORTAL_INVITATION_ALREADY_USED',
    PORTAL_USER_EXISTS: 'PORTAL_USER_EXISTS',
    PORTAL_CSRF_INVALID: 'PORTAL_CSRF_INVALID',
    PORTAL_SESSION_INVALID: 'PORTAL_SESSION_INVALID',
    // Benachrichtigungen und Stammdaten
    NOTIFICATION_NOT_FOUND: 'NOTIFICATION_NOT_FOUND',
    COMPANY_PROFILE_INCOMPLETE: 'COMPANY_PROFILE_INCOMPLETE',
    COMPANY_LOGO_INVALID: 'COMPANY_LOGO_INVALID',
    COMPANY_COLOR_INVALID: 'COMPANY_COLOR_INVALID',
    NEWSLETTER_NOT_CONFIGURED: 'NEWSLETTER_NOT_CONFIGURED',
    NEWSLETTER_DOI_INVALID: 'NEWSLETTER_DOI_INVALID',
    NEWSLETTER_DOI_EXPIRED: 'NEWSLETTER_DOI_EXPIRED',
    NEWSLETTER_DOI_ALREADY_USED: 'NEWSLETTER_DOI_ALREADY_USED',
    NEWSLETTER_PUBLIC_SESSION_INVALID: 'NEWSLETTER_PUBLIC_SESSION_INVALID',
    NEWSLETTER_NEW_DOI_REQUIRED: 'NEWSLETTER_NEW_DOI_REQUIRED',
    NEWSLETTER_EXISTING_CUSTOMER_DISABLED: 'NEWSLETTER_EXISTING_CUSTOMER_DISABLED',
    NEWSLETTER_EXISTING_CUSTOMER_INCOMPLETE: 'NEWSLETTER_EXISTING_CUSTOMER_INCOMPLETE',
    NEWSLETTER_RECIPIENT_SUPPRESSED: 'NEWSLETTER_RECIPIENT_SUPPRESSED',
    NEWSLETTER_SUPPRESSION_IRREVERSIBLE: 'NEWSLETTER_SUPPRESSION_IRREVERSIBLE',
    NEWSLETTER_SEGMENT_INVALID: 'NEWSLETTER_SEGMENT_INVALID',
    NEWSLETTER_CUSTOM_FIELD_NOT_APPROVED: 'NEWSLETTER_CUSTOM_FIELD_NOT_APPROVED',
    NEWSLETTER_IMPORT_INVALID: 'NEWSLETTER_IMPORT_INVALID',
    NEWSLETTER_CONTENT_INVALID: 'NEWSLETTER_CONTENT_INVALID',
    NEWSLETTER_CAMPAIGN_NOT_READY: 'NEWSLETTER_CAMPAIGN_NOT_READY',
    NEWSLETTER_TEST_RECIPIENT_INVALID: 'NEWSLETTER_TEST_RECIPIENT_INVALID',
    NEWSLETTER_WORKFLOW_CONFLICT: 'NEWSLETTER_WORKFLOW_CONFLICT',
    NEWSLETTER_FOUR_EYES_REQUIRED: 'NEWSLETTER_FOUR_EYES_REQUIRED',
    NEWSLETTER_SEND_BLOCKED: 'NEWSLETTER_SEND_BLOCKED',
    NEWSLETTER_PROVIDER_INVALID: 'NEWSLETTER_PROVIDER_INVALID',
    NEWSLETTER_DELIVERY_FAILED: 'NEWSLETTER_DELIVERY_FAILED',
    NEWSLETTER_DOMAIN_NOT_VERIFIED: 'NEWSLETTER_DOMAIN_NOT_VERIFIED',
    NEWSLETTER_WEBHOOK_SIGNATURE_INVALID: 'NEWSLETTER_WEBHOOK_SIGNATURE_INVALID',
    NEWSLETTER_TRACKING_APPROVAL_REQUIRED: 'NEWSLETTER_TRACKING_APPROVAL_REQUIRED',
    NEWSLETTER_TRACKING_LEGAL_TEXT_REQUIRED: 'NEWSLETTER_TRACKING_LEGAL_TEXT_REQUIRED',
    NEWSLETTER_TRACKING_NOT_READY: 'NEWSLETTER_TRACKING_NOT_READY',
    NEWSLETTER_ANALYTICS_WINDOW_INVALID: 'NEWSLETTER_ANALYTICS_WINDOW_INVALID',
    // PDF-Vorlagen
    PDF_TEMPLATE_NOT_FOUND: 'PDF_TEMPLATE_NOT_FOUND',
    PDF_TEMPLATE_NAME_TAKEN: 'PDF_TEMPLATE_NAME_TAKEN',
    PDF_TEMPLATE_DEFAULT_REQUIRED: 'PDF_TEMPLATE_DEFAULT_REQUIRED',
    PDF_TEMPLATE_INACTIVE: 'PDF_TEMPLATE_INACTIVE',
    PDF_TEMPLATE_LIMIT_REACHED: 'PDF_TEMPLATE_LIMIT_REACHED',
    PDF_TEMPLATE_SAMPLE_MISSING: 'PDF_TEMPLATE_SAMPLE_MISSING',
    LABEL_FORMAT_NOT_FOUND: 'LABEL_FORMAT_NOT_FOUND',
    LABEL_FORMAT_NAME_TAKEN: 'LABEL_FORMAT_NAME_TAKEN',
    LABEL_FORMAT_IN_USE: 'LABEL_FORMAT_IN_USE',
    LABEL_TEMPLATE_NOT_FOUND: 'LABEL_TEMPLATE_NOT_FOUND',
    LABEL_TEMPLATE_NAME_TAKEN: 'LABEL_TEMPLATE_NAME_TAKEN',
    LABEL_TEMPLATE_VERSION_NOT_FOUND: 'LABEL_TEMPLATE_VERSION_NOT_FOUND',
    LABEL_TEMPLATE_IMMUTABLE: 'LABEL_TEMPLATE_IMMUTABLE',
    LABEL_TEMPLATE_STATE_INVALID: 'LABEL_TEMPLATE_STATE_INVALID',
    LABEL_TEMPLATE_FOUR_EYES_REQUIRED: 'LABEL_TEMPLATE_FOUR_EYES_REQUIRED',
    LABEL_SOURCE_INVALID: 'LABEL_SOURCE_INVALID',
    LABEL_PRINT_NOT_FOUND: 'LABEL_PRINT_NOT_FOUND',
    LABEL_PRINT_VERSION_UNAPPROVED: 'LABEL_PRINT_VERSION_UNAPPROVED',
    LABEL_PRINT_IDEMPOTENCY_CONFLICT: 'LABEL_PRINT_IDEMPOTENCY_CONFLICT',
    LABEL_REPRINT_REASON_REQUIRED: 'LABEL_REPRINT_REASON_REQUIRED',
    LABEL_PRINT_FILE_INTEGRITY_FAILED: 'LABEL_PRINT_FILE_INTEGRITY_FAILED',
    // Änderungsmanagement
    CHANGE_REQUEST_NOT_FOUND: 'CHANGE_REQUEST_NOT_FOUND',
    CHANGE_REQUEST_STATE_INVALID: 'CHANGE_REQUEST_STATE_INVALID',
    CHANGE_REQUEST_SOURCE_INVALID: 'CHANGE_REQUEST_SOURCE_INVALID',
    CHANGE_REQUEST_IMPACT_REQUIRED: 'CHANGE_REQUEST_IMPACT_REQUIRED',
    CHANGE_REQUEST_IMPACT_STALE: 'CHANGE_REQUEST_IMPACT_STALE',
    CHANGE_REQUEST_FOUR_EYES_REQUIRED: 'CHANGE_REQUEST_FOUR_EYES_REQUIRED',
    CHANGE_REQUEST_TASKS_OPEN: 'CHANGE_REQUEST_TASKS_OPEN',
    CHANGE_REQUEST_DRAFT_TARGET_INVALID: 'CHANGE_REQUEST_DRAFT_TARGET_INVALID',
    CHANGE_REQUEST_IDEMPOTENCY_CONFLICT: 'CHANGE_REQUEST_IDEMPOTENCY_CONFLICT',
    CUSTOMER_PRODUCT_APPROVAL_NOT_FOUND: 'CUSTOMER_PRODUCT_APPROVAL_NOT_FOUND',
    CUSTOMER_PRODUCT_APPROVAL_STATE_INVALID: 'CUSTOMER_PRODUCT_APPROVAL_STATE_INVALID',
    // Administration
    AUDIT_CHAIN_BROKEN: 'AUDIT_CHAIN_BROKEN',
    IMPORT_FILE_INVALID: 'IMPORT_FILE_INVALID',
    IMPORT_MAPPING_INCOMPLETE: 'IMPORT_MAPPING_INCOMPLETE',
    IMPORT_JOB_NOT_ROLLBACKABLE: 'IMPORT_JOB_NOT_ROLLBACKABLE',
    IMPORT_PROFILE_VERSION_CONFLICT: 'IMPORT_PROFILE_VERSION_CONFLICT',
    IMPORT_ROLLBACK_CHECK_STALE: 'IMPORT_ROLLBACK_CHECK_STALE',
    IMPORT_ROW_LIMIT_EXCEEDED: 'IMPORT_ROW_LIMIT_EXCEEDED',
    IMPORT_PREVIEW_REQUIRED: 'IMPORT_PREVIEW_REQUIRED',
    IMPORT_CONFIRMATION_REQUIRED: 'IMPORT_CONFIRMATION_REQUIRED',
    IMPORT_DUPLICATE_DECISION_REQUIRED: 'IMPORT_DUPLICATE_DECISION_REQUIRED',
    IMPORT_JOB_NOT_RESUMABLE: 'IMPORT_JOB_NOT_RESUMABLE',
    IMPORT_ROW_INVALID: 'IMPORT_ROW_INVALID',
    BACKUP_UNAVAILABLE: 'BACKUP_UNAVAILABLE',
    BACKUP_NOT_FOUND: 'BACKUP_NOT_FOUND',
    MAIL_CONNECTION_FAILED: 'MAIL_CONNECTION_FAILED',
    MAINTENANCE_MODE_ACTIVE: 'MAINTENANCE_MODE_ACTIVE',
    // WhatsApp Business Cloud API
    WHATSAPP_NOT_CONFIGURED: 'WHATSAPP_NOT_CONFIGURED',
    WHATSAPP_SIGNATURE_INVALID: 'WHATSAPP_SIGNATURE_INVALID',
    WHATSAPP_WINDOW_EXPIRED: 'WHATSAPP_WINDOW_EXPIRED',
    WHATSAPP_OPT_IN_MISSING: 'WHATSAPP_OPT_IN_MISSING',
    WHATSAPP_PHONE_NUMBER_INVALID: 'WHATSAPP_PHONE_NUMBER_INVALID',
    WHATSAPP_TEMPLATE_NOT_APPROVED: 'WHATSAPP_TEMPLATE_NOT_APPROVED',
    WHATSAPP_TEMPLATE_PARAMS_MISMATCH: 'WHATSAPP_TEMPLATE_PARAMS_MISMATCH',
    WHATSAPP_API_ERROR: 'WHATSAPP_API_ERROR',
    WHATSAPP_MEDIA_TOO_LARGE: 'WHATSAPP_MEDIA_TOO_LARGE',
    WHATSAPP_MEDIA_NOT_FOUND: 'WHATSAPP_MEDIA_NOT_FOUND',
    // Kundenverwaltung
    CUSTOMER_NUMBER_TAKEN: 'CUSTOMER_NUMBER_TAKEN',
    CUSTOMER_VAT_ID_INVALID: 'CUSTOMER_VAT_ID_INVALID',
    CUSTOMER_HAS_DOCUMENTS: 'CUSTOMER_HAS_DOCUMENTS',
    CUSTOMER_NAME_REQUIRED: 'CUSTOMER_NAME_REQUIRED',
    CUSTOMER_LOCKED: 'CUSTOMER_LOCKED',
    // Geschäftspartner
    PARTNER_NUMBER_TAKEN: 'PARTNER_NUMBER_TAKEN',
    PARTNER_ROLE_REQUIRED: 'PARTNER_ROLE_REQUIRED',
    PARTNER_NOT_A_PROSPECT: 'PARTNER_NOT_A_PROSPECT',
    PARTNER_ALREADY_CUSTOMER: 'PARTNER_ALREADY_CUSTOMER',
    PARTNER_NOT_A_SUPPLIER: 'PARTNER_NOT_A_SUPPLIER',
    PARTNER_LEAD_STAGE_INVALID: 'PARTNER_LEAD_STAGE_INVALID',
    PARTNER_LOST_REASON_REQUIRED: 'PARTNER_LOST_REASON_REQUIRED',
    PARTNER_NOT_BLOCKED: 'PARTNER_NOT_BLOCKED',
    PARTNER_RISK_STATUS_LOCK_REQUIRED: 'PARTNER_RISK_STATUS_LOCK_REQUIRED',
    DEBTOR_ACCOUNT_OUT_OF_RANGE: 'DEBTOR_ACCOUNT_OUT_OF_RANGE',
    CREDITOR_ACCOUNT_TAKEN: 'CREDITOR_ACCOUNT_TAKEN',
    CREDITOR_ACCOUNT_OUT_OF_RANGE: 'CREDITOR_ACCOUNT_OUT_OF_RANGE',
    SUPPLIER_PRODUCT_EXISTS: 'SUPPLIER_PRODUCT_EXISTS',
    SUPPLIER_PRODUCT_NOT_FOUND: 'SUPPLIER_PRODUCT_NOT_FOUND',
    // Zusatzfelder
    CUSTOM_FIELD_KEY_TAKEN: 'CUSTOM_FIELD_KEY_TAKEN',
    CUSTOM_FIELD_VALUE_INVALID: 'CUSTOM_FIELD_VALUE_INVALID',
    CUSTOM_FIELD_IN_USE: 'CUSTOM_FIELD_IN_USE',
    CUSTOM_FIELD_GROUP_KEY_TAKEN: 'CUSTOM_FIELD_GROUP_KEY_TAKEN',
    CUSTOM_FIELD_GROUP_IN_USE: 'CUSTOM_FIELD_GROUP_IN_USE',
    CUSTOM_FIELD_SCOPE_INVALID: 'CUSTOM_FIELD_SCOPE_INVALID',
    CUSTOM_FIELD_CONFIDENTIAL_FORBIDDEN: 'CUSTOM_FIELD_CONFIDENTIAL_FORBIDDEN',
    TRANSLATION_SERVICE_UNAVAILABLE: 'TRANSLATION_SERVICE_UNAVAILABLE',
    TRANSLATION_RESPONSE_INVALID: 'TRANSLATION_RESPONSE_INVALID',
    TRANSLATION_PROTECTED_CONTENT_CHANGED: 'TRANSLATION_PROTECTED_CONTENT_CHANGED',
    TRANSLATION_GLOSSARY_CONFLICT: 'TRANSLATION_GLOSSARY_CONFLICT',
    // Artikelstamm
    PRODUCT_NUMBER_TAKEN: 'PRODUCT_NUMBER_TAKEN',
    PRODUCT_EAN_TAKEN: 'PRODUCT_EAN_TAKEN',
    PRODUCT_HAS_MOVEMENTS: 'PRODUCT_HAS_MOVEMENTS',
    PRODUCT_BASE_UNIT_LOCKED: 'PRODUCT_BASE_UNIT_LOCKED',
    PRICE_TIER_DUPLICATE: 'PRICE_TIER_DUPLICATE',
    PACKAGING_CODE_DUPLICATE: 'PACKAGING_CODE_DUPLICATE',
    PRODUCT_PACKAGING_INVALID: 'PRODUCT_PACKAGING_INVALID',
    QUANTITY_NOT_IN_STEP: 'QUANTITY_NOT_IN_STEP',
    PRODUCT_IMAGE_INVALID: 'PRODUCT_IMAGE_INVALID',
    PRODUCT_IMAGE_LIMIT_REACHED: 'PRODUCT_IMAGE_LIMIT_REACHED',
    PRODUCT_IMAGE_PROCESSING_FAILED: 'PRODUCT_IMAGE_PROCESSING_FAILED',
    PRODUCT_IMAGE_NOT_FOUND: 'PRODUCT_IMAGE_NOT_FOUND',
    PRODUCT_CATEGORY_NOT_FOUND: 'PRODUCT_CATEGORY_NOT_FOUND',
    PRODUCT_CATEGORY_SLUG_TAKEN: 'PRODUCT_CATEGORY_SLUG_TAKEN',
    PRODUCT_CATEGORY_CYCLE: 'PRODUCT_CATEGORY_CYCLE',
    PRODUCT_CATEGORY_HAS_CHILDREN: 'PRODUCT_CATEGORY_HAS_CHILDREN',
    PRODUCT_CATEGORY_INACTIVE: 'PRODUCT_CATEGORY_INACTIVE',
    PRODUCT_MASTER_PROFILE_NOT_FOUND: 'PRODUCT_MASTER_PROFILE_NOT_FOUND',
    PRODUCT_MASTER_PROFILE_IMMUTABLE: 'PRODUCT_MASTER_PROFILE_IMMUTABLE',
    PRODUCT_MASTER_PROFILE_STATE_INVALID: 'PRODUCT_MASTER_PROFILE_STATE_INVALID',
    PRODUCT_MASTER_PROFILE_FOUR_EYES_REQUIRED: 'PRODUCT_MASTER_PROFILE_FOUR_EYES_REQUIRED',
    PRODUCT_PROFILE_DEFINITION_INVALID: 'PRODUCT_PROFILE_DEFINITION_INVALID',
    PRODUCT_PROFILE_DEFINITION_NOT_FOUND: 'PRODUCT_PROFILE_DEFINITION_NOT_FOUND',
    PRODUCT_DMS_ATTACHMENT_INVALID: 'PRODUCT_DMS_ATTACHMENT_INVALID',
    PRODUCT_UNIT_CONVERSION_INVALID: 'PRODUCT_UNIT_CONVERSION_INVALID',
    RECIPE_NUMBER_TAKEN: 'RECIPE_NUMBER_TAKEN',
    RECIPE_VERSION_NOT_FOUND: 'RECIPE_VERSION_NOT_FOUND',
    RECIPE_VERSION_IMMUTABLE: 'RECIPE_VERSION_IMMUTABLE',
    RECIPE_STATE_INVALID: 'RECIPE_STATE_INVALID',
    RECIPE_CYCLE_DETECTED: 'RECIPE_CYCLE_DETECTED',
    RECIPE_COMPONENT_INVALID: 'RECIPE_COMPONENT_INVALID',
    RECIPE_SUBSTITUTION_INVALID: 'RECIPE_SUBSTITUTION_INVALID',
    RECIPE_DMS_ATTACHMENT_INVALID: 'RECIPE_DMS_ATTACHMENT_INVALID',
    RECIPE_UNIT_INVALID: 'RECIPE_UNIT_INVALID',
    RECIPE_COST_UNAVAILABLE: 'RECIPE_COST_UNAVAILABLE',
    PROCESS_ROUTING_NUMBER_TAKEN: 'PROCESS_ROUTING_NUMBER_TAKEN',
    PROCESS_ROUTING_NOT_FOUND: 'PROCESS_ROUTING_NOT_FOUND',
    PROCESS_ROUTING_IMMUTABLE: 'PROCESS_ROUTING_IMMUTABLE',
    PROCESS_ROUTING_STATE_INVALID: 'PROCESS_ROUTING_STATE_INVALID',
    PROCESS_ROUTING_DMS_ATTACHMENT_INVALID: 'PROCESS_ROUTING_DMS_ATTACHMENT_INVALID',
    PROCESS_ROUTING_UNIT_INVALID: 'PROCESS_ROUTING_UNIT_INVALID',
    BATCH_SCALING_INVALID: 'BATCH_SCALING_INVALID',
    BATCH_SCALING_CYCLE_DETECTED: 'BATCH_SCALING_CYCLE_DETECTED',
    BATCH_SCALING_MATERIAL_MISSING: 'BATCH_SCALING_MATERIAL_MISSING',
    DECLARATION_CATALOG_KEY_TAKEN: 'DECLARATION_CATALOG_KEY_TAKEN',
    DECLARATION_CATALOG_NOT_FOUND: 'DECLARATION_CATALOG_NOT_FOUND',
    DECLARATION_CATALOG_STATE_INVALID: 'DECLARATION_CATALOG_STATE_INVALID',
    DECLARATION_CATALOG_REFERENCE_INVALID: 'DECLARATION_CATALOG_REFERENCE_INVALID',
    PRODUCT_DECLARATION_NOT_FOUND: 'PRODUCT_DECLARATION_NOT_FOUND',
    PRODUCT_DECLARATION_NUMBER_TAKEN: 'PRODUCT_DECLARATION_NUMBER_TAKEN',
    PRODUCT_DECLARATION_STATE_INVALID: 'PRODUCT_DECLARATION_STATE_INVALID',
    PRODUCT_DECLARATION_SOURCE_INVALID: 'PRODUCT_DECLARATION_SOURCE_INVALID',
    PRODUCT_DECLARATION_VALIDATION_FAILED: 'PRODUCT_DECLARATION_VALIDATION_FAILED',
    PRODUCT_DECLARATION_FOUR_EYES_REQUIRED: 'PRODUCT_DECLARATION_FOUR_EYES_REQUIRED',
    ANALYSIS_PARAMETER_KEY_TAKEN: 'ANALYSIS_PARAMETER_KEY_TAKEN',
    ANALYSIS_PARAMETER_NOT_FOUND: 'ANALYSIS_PARAMETER_NOT_FOUND',
    ANALYSIS_PARAMETER_STATE_INVALID: 'ANALYSIS_PARAMETER_STATE_INVALID',
    ANALYSIS_PROFILE_NUMBER_TAKEN: 'ANALYSIS_PROFILE_NUMBER_TAKEN',
    ANALYSIS_PROFILE_NOT_FOUND: 'ANALYSIS_PROFILE_NOT_FOUND',
    ANALYSIS_PROFILE_STATE_INVALID: 'ANALYSIS_PROFILE_STATE_INVALID',
    ANALYSIS_SOURCE_INVALID: 'ANALYSIS_SOURCE_INVALID',
    ANALYSIS_CALCULATION_FAILED: 'ANALYSIS_CALCULATION_FAILED',
    ANALYSIS_FOUR_EYES_REQUIRED: 'ANALYSIS_FOUR_EYES_REQUIRED',
    PRODUCTION_ORDER_NOT_FOUND: 'PRODUCTION_ORDER_NOT_FOUND',
    PRODUCTION_ORDER_NUMBER_TAKEN: 'PRODUCTION_ORDER_NUMBER_TAKEN',
    PRODUCTION_ORDER_STATE_INVALID: 'PRODUCTION_ORDER_STATE_INVALID',
    PRODUCTION_ORDER_SOURCE_INVALID: 'PRODUCTION_ORDER_SOURCE_INVALID',
    MRP_RUN_NOT_FOUND: 'MRP_RUN_NOT_FOUND',
    MRP_RUN_INPUT_CONFLICT: 'MRP_RUN_INPUT_CONFLICT',
    MRP_POLICY_CONFLICT: 'MRP_POLICY_CONFLICT',
    MRP_SUGGESTION_NOT_FOUND: 'MRP_SUGGESTION_NOT_FOUND',
    MRP_SUGGESTION_STATE_INVALID: 'MRP_SUGGESTION_STATE_INVALID',
    MRP_SUGGESTION_CONVERSION_INVALID: 'MRP_SUGGESTION_CONVERSION_INVALID',
    MRP_OPERATION_CONFLICT: 'MRP_OPERATION_CONFLICT',
    PRODUCTION_ORDER_VERSION_CONFLICT: 'PRODUCTION_ORDER_VERSION_CONFLICT',
    PRODUCTION_RESERVATION_INSUFFICIENT: 'PRODUCTION_RESERVATION_INSUFFICIENT',
    PRODUCTION_CONSUMPTION_INVALID: 'PRODUCTION_CONSUMPTION_INVALID',
    PRODUCTION_COMPLETION_INVALID: 'PRODUCTION_COMPLETION_INVALID',
    PRODUCTION_QUALITY_INCOMPLETE: 'PRODUCTION_QUALITY_INCOMPLETE',
    PRODUCTION_IDEMPOTENCY_CONFLICT: 'PRODUCTION_IDEMPOTENCY_CONFLICT',
    TRACEABILITY_ANCHOR_REQUIRED: 'TRACEABILITY_ANCHOR_REQUIRED',
    TRACEABILITY_LIMIT_EXCEEDED: 'TRACEABILITY_LIMIT_EXCEEDED',
    RECALL_SIMULATION_NOT_FOUND: 'RECALL_SIMULATION_NOT_FOUND',
    RECALL_SIMULATION_STATE_INVALID: 'RECALL_SIMULATION_STATE_INVALID',
    RECALL_SIMULATION_VERSION_CONFLICT: 'RECALL_SIMULATION_VERSION_CONFLICT',
    RECALL_SIMULATION_IDEMPOTENCY_CONFLICT: 'RECALL_SIMULATION_IDEMPOTENCY_CONFLICT',
    // Bestand und Chargen
    STOCK_ADJUSTMENT_CONFLICT: 'STOCK_ADJUSTMENT_CONFLICT',
    BATCH_NUMBER_TAKEN: 'BATCH_NUMBER_TAKEN',
    BATCH_REQUIRED: 'BATCH_REQUIRED',
    BATCH_NOT_AVAILABLE: 'BATCH_NOT_AVAILABLE',
    BATCH_NOT_EMPTY: 'BATCH_NOT_EMPTY',
    STOCK_INSUFFICIENT: 'STOCK_INSUFFICIENT',
    STOCK_ADJUSTMENT_ZERO: 'STOCK_ADJUSTMENT_ZERO',
    SHELF_LIFE_TOO_SHORT: 'SHELF_LIFE_TOO_SHORT',
    STOCK_NOT_MANAGED: 'STOCK_NOT_MANAGED',
    // Nummernkreise
    NUMBER_RANGE_MISSING: 'NUMBER_RANGE_MISSING',
    // Belege
    DOCUMENT_NUMBER_TAKEN: 'DOCUMENT_NUMBER_TAKEN',
    DOCUMENT_LOCKED: 'DOCUMENT_LOCKED',
    DOCUMENT_EMPTY: 'DOCUMENT_EMPTY',
    DOCUMENT_CANCELLED: 'DOCUMENT_CANCELLED',
    DOCUMENT_CONVERSION_NOT_ALLOWED: 'DOCUMENT_CONVERSION_NOT_ALLOWED',
    DOCUMENT_FIELD_HISTORY_UNAVAILABLE: 'DOCUMENT_FIELD_HISTORY_UNAVAILABLE',
    DOCUMENT_ALREADY_CONVERTED: 'DOCUMENT_ALREADY_CONVERTED',
    DOCUMENT_STATUS_TRANSITION_INVALID: 'DOCUMENT_STATUS_TRANSITION_INVALID',
    DOCUMENT_TOTALS_MISMATCH: 'DOCUMENT_TOTALS_MISMATCH',
    DOCUMENT_MANDATORY_FIELD_MISSING: 'DOCUMENT_MANDATORY_FIELD_MISSING',
    DOCUMENT_ITEM_POSITION_DUPLICATE: 'DOCUMENT_ITEM_POSITION_DUPLICATE',
    DOCUMENT_PRICE_UNRESOLVED: 'DOCUMENT_PRICE_UNRESOLVED',
    DOCUMENT_CUSTOMER_BILLING_INCOMPLETE: 'DOCUMENT_CUSTOMER_BILLING_INCOMPLETE',
    TAX_EXEMPTION_NOT_PROVEN: 'TAX_EXEMPTION_NOT_PROVEN',
    TAX_OVERRIDE_FORBIDDEN: 'TAX_OVERRIDE_FORBIDDEN',
    TAX_OVERRIDE_REASON_REQUIRED: 'TAX_OVERRIDE_REASON_REQUIRED',
    // Dokumentenmanagement
    DMS_FILE_INVALID: 'DMS_FILE_INVALID',
    DMS_FILE_MISSING: 'DMS_FILE_MISSING',
    DMS_ENTITY_NOT_FOUND: 'DMS_ENTITY_NOT_FOUND',
    // Belegversand
    EMAIL_SEND_FAILED: 'EMAIL_SEND_FAILED',
    // Buchhaltung und Meldewesen
    ACCOUNTING_SETTINGS_INCOMPLETE: 'ACCOUNTING_SETTINGS_INCOMPLETE',
    DATEV_EXPORT_BLOCKED: 'DATEV_EXPORT_BLOCKED',
    DATEV_EXPORT_EMPTY: 'DATEV_EXPORT_EMPTY',
    DATEV_PERIOD_ALREADY_EXPORTED: 'DATEV_PERIOD_ALREADY_EXPORTED',
    DEBTOR_ACCOUNT_TAKEN: 'DEBTOR_ACCOUNT_TAKEN',
    DEBTOR_ACCOUNT_RANGE_EXHAUSTED: 'DEBTOR_ACCOUNT_RANGE_EXHAUSTED',
    CREDITOR_ACCOUNT_RANGE_EXHAUSTED: 'CREDITOR_ACCOUNT_RANGE_EXHAUSTED',
    INTRASTAT_EXPORT_BLOCKED: 'INTRASTAT_EXPORT_BLOCKED',
    INTRASTAT_EXPORT_EMPTY: 'INTRASTAT_EXPORT_EMPTY',
    // Einkauf
    PURCHASE_ORDER_NOT_EDITABLE: 'PURCHASE_ORDER_NOT_EDITABLE',
    PURCHASE_ORDER_NOT_CANCELLABLE: 'PURCHASE_ORDER_NOT_CANCELLABLE',
    PURCHASE_ORDER_EMPTY: 'PURCHASE_ORDER_EMPTY',
    PURCHASE_ORDER_SUPPLIER_INVALID: 'PURCHASE_ORDER_SUPPLIER_INVALID',
    PURCHASE_ORDER_MIN_VALUE_NOT_REACHED: 'PURCHASE_ORDER_MIN_VALUE_NOT_REACHED',
    GOODS_RECEIPT_NOT_EDITABLE: 'GOODS_RECEIPT_NOT_EDITABLE',
    GOODS_RECEIPT_ALREADY_POSTED: 'GOODS_RECEIPT_ALREADY_POSTED',
    GOODS_RECEIPT_QUANTITY_EXCEEDED: 'GOODS_RECEIPT_QUANTITY_EXCEEDED',
    GOODS_RECEIPT_BATCH_REQUIRED: 'GOODS_RECEIPT_BATCH_REQUIRED',
    GOODS_RECEIPT_SUPPLIER_MISMATCH: 'GOODS_RECEIPT_SUPPLIER_MISMATCH',
    VENDOR_INVOICE_NUMBER_TAKEN: 'VENDOR_INVOICE_NUMBER_TAKEN',
    VENDOR_INVOICE_NOT_EDITABLE: 'VENDOR_INVOICE_NOT_EDITABLE',
    VENDOR_INVOICE_NOT_MATCHED: 'VENDOR_INVOICE_NOT_MATCHED',
    VENDOR_INVOICE_DISCREPANCY_BLOCKED: 'VENDOR_INVOICE_DISCREPANCY_BLOCKED',
    VENDOR_INVOICE_ALREADY_APPROVED: 'VENDOR_INVOICE_ALREADY_APPROVED',
    VENDOR_INVOICE_CREDITOR_MISSING: 'VENDOR_INVOICE_CREDITOR_MISSING',
    PROCUREMENT_DOCUMENT_INVALID: 'PROCUREMENT_DOCUMENT_INVALID',
    PROCUREMENT_DOCUMENT_NOT_FOUND: 'PROCUREMENT_DOCUMENT_NOT_FOUND',
    // Telefonie und KI-Audio-Pipeline
    TELEPHONY_NOT_ENABLED: 'TELEPHONY_NOT_ENABLED',
    TELEPHONY_PROVIDER_NOT_CONFIGURED: 'TELEPHONY_PROVIDER_NOT_CONFIGURED',
    TELEPHONY_PROVIDER_ERROR: 'TELEPHONY_PROVIDER_ERROR',
    TELEPHONY_IDENTIFIER_IN_USE: 'TELEPHONY_IDENTIFIER_IN_USE',
    TELEPHONY_WEBHOOK_SECRET_MISSING: 'TELEPHONY_WEBHOOK_SECRET_MISSING',
    TELEPHONY_LOG_NOT_FOUND: 'TELEPHONY_LOG_NOT_FOUND',
    TELEPHONY_RECORDING_MISSING: 'TELEPHONY_RECORDING_MISSING',
    TELEPHONY_AUDIO_FORMAT_UNSUPPORTED: 'TELEPHONY_AUDIO_FORMAT_UNSUPPORTED',
    TELEPHONY_AI_DISABLED: 'TELEPHONY_AI_DISABLED',
    TELEPHONY_AI_ALREADY_RUNNING: 'TELEPHONY_AI_ALREADY_RUNNING',
    TELEPHONY_TRANSCRIPTION_FAILED: 'TELEPHONY_TRANSCRIPTION_FAILED',
    TELEPHONY_SUMMARY_FAILED: 'TELEPHONY_SUMMARY_FAILED',
    CONTACT_CHANNEL_BLOCKED: 'CONTACT_CHANNEL_BLOCKED',
    CONTACT_MARKETING_BLOCKED: 'CONTACT_MARKETING_BLOCKED',
    // Außendienst und Fragebögen
    QUESTIONNAIRE_TEMPLATE_NOT_FOUND: 'QUESTIONNAIRE_TEMPLATE_NOT_FOUND',
    QUESTIONNAIRE_TEMPLATE_NAME_TAKEN: 'QUESTIONNAIRE_TEMPLATE_NAME_TAKEN',
    QUESTIONNAIRE_TEMPLATE_INVALID: 'QUESTIONNAIRE_TEMPLATE_INVALID',
    QUESTIONNAIRE_TEMPLATE_NOT_PUBLISHED: 'QUESTIONNAIRE_TEMPLATE_NOT_PUBLISHED',
    QUESTIONNAIRE_VERSION_NOT_FOUND: 'QUESTIONNAIRE_VERSION_NOT_FOUND',
    QUESTIONNAIRE_VERSION_IMMUTABLE: 'QUESTIONNAIRE_VERSION_IMMUTABLE',
    QUESTIONNAIRE_VERSION_CONFLICT: 'QUESTIONNAIRE_VERSION_CONFLICT',
    QUESTIONNAIRE_LOGIC_CYCLE: 'QUESTIONNAIRE_LOGIC_CYCLE',
    QUESTIONNAIRE_LOGIC_REFERENCE_INVALID: 'QUESTIONNAIRE_LOGIC_REFERENCE_INVALID',
    QUESTIONNAIRE_RUN_NOT_FOUND: 'QUESTIONNAIRE_RUN_NOT_FOUND',
    QUESTIONNAIRE_RUN_STATE_INVALID: 'QUESTIONNAIRE_RUN_STATE_INVALID',
    QUESTIONNAIRE_RUN_IMMUTABLE: 'QUESTIONNAIRE_RUN_IMMUTABLE',
    QUESTIONNAIRE_ANSWER_INVALID: 'QUESTIONNAIRE_ANSWER_INVALID',
    QUESTIONNAIRE_REQUIRED_ANSWER_MISSING: 'QUESTIONNAIRE_REQUIRED_ANSWER_MISSING',
    QUESTIONNAIRE_IDEMPOTENCY_CONFLICT: 'QUESTIONNAIRE_IDEMPOTENCY_CONFLICT',
    QUESTIONNAIRE_SYNC_CONFLICT: 'QUESTIONNAIRE_SYNC_CONFLICT',
    QUESTIONNAIRE_CUSTOMER_SESSION_INVALID: 'QUESTIONNAIRE_CUSTOMER_SESSION_INVALID',
    QUESTIONNAIRE_CUSTOMER_SESSION_EXPIRED: 'QUESTIONNAIRE_CUSTOMER_SESSION_EXPIRED',
    QUESTIONNAIRE_CUSTOMER_SESSION_LOCKED: 'QUESTIONNAIRE_CUSTOMER_SESSION_LOCKED',
    QUESTIONNAIRE_ATTACHMENT_INVALID: 'QUESTIONNAIRE_ATTACHMENT_INVALID',
    QUESTIONNAIRE_ATTACHMENT_LIMIT_REACHED: 'QUESTIONNAIRE_ATTACHMENT_LIMIT_REACHED',
    QUESTIONNAIRE_PRODUCT_INVALID: 'QUESTIONNAIRE_PRODUCT_INVALID',
    QUESTIONNAIRE_PARTNER_REQUIRED: 'QUESTIONNAIRE_PARTNER_REQUIRED',
    QUESTIONNAIRE_CONSENT_REQUIRED: 'QUESTIONNAIRE_CONSENT_REQUIRED',
    QUESTIONNAIRE_LANGUAGE_UNAVAILABLE: 'QUESTIONNAIRE_LANGUAGE_UNAVAILABLE',
    QUESTIONNAIRE_OFFLINE_UNAVAILABLE: 'QUESTIONNAIRE_OFFLINE_UNAVAILABLE',
    QUESTIONNAIRE_RETENTION_LOCKED: 'QUESTIONNAIRE_RETENTION_LOCKED',
    QUESTIONNAIRE_LEGAL_HOLD_INVALID: 'QUESTIONNAIRE_LEGAL_HOLD_INVALID',
    QUESTIONNAIRE_COMPLETION_ACTION_FAILED: 'QUESTIONNAIRE_COMPLETION_ACTION_FAILED',
    QUESTIONNAIRE_EXPORT_TOO_LARGE: 'QUESTIONNAIRE_EXPORT_TOO_LARGE',
    QUESTIONNAIRE_EXPORT_JOB_NOT_FOUND: 'QUESTIONNAIRE_EXPORT_JOB_NOT_FOUND',
    QUESTIONNAIRE_EXPORT_JOB_NOT_READY: 'QUESTIONNAIRE_EXPORT_JOB_NOT_READY',
    QUESTIONNAIRE_EXPORT_JOB_FAILED: 'QUESTIONNAIRE_EXPORT_JOB_FAILED',
    QUESTIONNAIRE_EXPORT_QUEUE_UNAVAILABLE: 'QUESTIONNAIRE_EXPORT_QUEUE_UNAVAILABLE',
};
//# sourceMappingURL=error-codes.js.map